import { createRouter, createWebHistory } from "vue-router";
import store from "../store"; // Import Vuex store
import Home from "../pages/Home.vue";
import CourseDetailsDynamic from "../pages/CourseDetailsDynamic.vue";
import CourseDetails from "../pages/CourseDetails.vue";
import CourseDetails2 from "../pages/CourseDetails2.vue";
import CourseDetails3 from "../pages/CourseDetails3.vue";
import DashboardLayout from "@/layout/admin/DashboardLayout.vue";
import Courses from "@/pages/Courses";
import Login from "@/pages/Login.vue";
import Signup from "@/pages/Signup.vue";
import api from "@/services/api";
import TermsOfService from "@/pages/termsOfService.vue";
import AllCourses from "@/pages/AllCourses.vue";

const routes = [
  { path: "/", name: "Home", component: Home, meta: { requiresGuest: false } },
  {
    path: "/allcourses",
    name: "AllCourses",
    component: AllCourses,
    meta: { requiresGuest: false },
  },
  {
    path: "/courses",
    name: "Courses",
    component: Courses,
    meta: { requiresGuest: false },
  },
  {
    path: "/programs",
    name: "ProgramsCourses",
    component: () => import("@/pages/Programs"),
    meta: { requiresGuest: false },
  },
  {
    path: "/trainings",
    name: "TrainingCourses",
    component: () => import("@/pages/Trainings"),
    meta: { requiresGuest: false },
  },
  {
    path:"/contact",
    name: "ContactUs",
    component: () => import("@/pages/Contact"),
    meta: { requiresGuest: false },
  },
  {
    path: "/privacy-policy",
    name: "PrivacyPolicy",
    component: () => import("@/pages/PrivacyPolicy"),
    meta: { requiresGuest: false },
  },
  {
    path: "/mission",
    name: "VisionAndMission",
    component: () => import("@/pages/visionMission"),
    meta: { requiresGuest: false },
  },
  {
    path: "/terms-service",
    name: "TermsAndServoce",
    component: TermsOfService,
    meta: { requiresGuest: false },
  },
  {
    path: "/feedback",
    name: "Feedback",
    component: () => import("@/pages/FeedbackForm"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/course-cart",
    name: "CourseCart",
    component: () => import("@/pages/Members/CourseCart"),
    meta: {
      requiresAuth: true,
      roles: ["student"],
    },
  },
  {
    path: "/checkout",
    name: "Checkout",
    component: () => import("@/pages/Members/Checkout"),
    meta: {
      requiresAuth: true,
      roles: ["student"],
    },
  },
  {
    // path: "/course-details/:courseName",
    path: "/course-detail/custom/the-lighthouse-leadership-program",
    name: "CourseDetails",
    component: CourseDetails,
    meta: { requiresGuest: false },
  },
  {
    path: "/course-detail/:id",
    name: "CourseDetailsDynamic",
    component: CourseDetailsDynamic,
    // meta: { requiresGuest: false },
  },
  {
    path: "/course-details/financial-literacy",
    name: "CourseDetails2",
    component: CourseDetails2,
    meta: { requiresGuest: false },
  },
  {
    path: "/course-details/financial-literacy-2",
    name: "CourseDetails3",
    component: CourseDetails3,
    meta: { requiresGuest: false },
  },
  {
    path: "/live-course-details/:id",
    name: "CourseDetails",
    component: () => import("../pages/Members/TestCourseDetails"),
  },
  {
    path: "/dashboard/courses/:id",
    component: () => import("@/pages/Admin/AdminCourseOverview.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/dashboard/courses/create",
    component: () => import("@/pages/AdminCreateCourse"),
    meta: { requiresAuth: true },
  },
  {
    path: "/dashboard/courses/edit/:id",
    component: () => import("@/pages/AdminEditCourse"),
    meta: { requiresAuth: true },
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: () => import("@/pages/ForgotPassword"),
    meta: { requiresGuest: true },
  },
  {
    path: "/reset-password/:token",
    name: "ResetPassword",
    component: () => import("@/pages/ResetPassword"),
    meta: { requiresGuest: true },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: { requiresGuest: true }, // Guests only
  },
  {
    path: "/signup",
    name: "Signup",
    component: Signup,
    meta: { requiresGuest: true }, // Guests only
  },
  // {
  //   path: "/dashboard",
  //   name: "Dashboard",
  //   component: Dashboard,
  //   meta: { requiresAuth: true }, // Requires login
  // },
  {
    path: "/for-mentors",
    name: "ForMentors",
    component: () => import("@/pages/Mentors/MentorsForm"),
    meta: { requiresGuest: false },
  },
  {
    path: "/financial-planning",
    name: "FinancialPlanning",
    component: () => import("@/pages/FinancialPlanning"),
  },
  {
    path: "/financial-calculators",
    name: "FinancialCalculators",
    component: () => import("@/pages/FinancialCalculators"),
  },
  {
    path: "/:catchAll(.*)",
    name: "NotFound",
    component: () => import("@/pages/NotFound"),
  },
  {
    path: "/unauthorized",
    name: "Unauthorized",
    component: () => import("@/pages/UnAuthorized"),
  },
  {
    path: "/dashboard",
    component: DashboardLayout,
    children: [
      {
        path: "allusers",
        name: "AdminUserManagement",
        component: () => import("../pages/Admin/AdminUserManagement"),
        meta: {
          requiresAuth: true,
          roles: ["admin"],
        },
      },
      {
        path: "students",
        name: "students",
        component: () => import("../pages/Admin/UserTypes/Students.vue"),
        meta: {
          requiresAuth: true,
          roles: ["admin"],
        },
      },
      {
        path: "all-mentors",
        name: "mentors",
        component: () => import("../pages/Admin/UserTypes/Mentors.vue"),
        meta: {
          requiresAuth: true,
          roles: ["admin"],
        },
      },
      {
        path: "teachers",
        name: "teachers",
        component: () => import("../pages/Admin/UserTypes/Teachers.vue"),
        meta: {
          requiresAuth: true,
          roles: ["admin"],
        },
      },
      {
        path: "profile",
        name: "Profile",
        component: () => import("@/pages/Profile"),
        meta: { requiresAuth: true },
      },
      {
        path: "teacher-profile",
        name: "TeacherProfile",
        component: () => import("@/pages/TeacherProfile"),
        meta: {
          requiresAuth: true,
          roles: ["teacher"],
        },
      },
      {
        path: "mycourses",
        name: "AdminMyCourse",
        component: () => import("@/pages/AdminMyCourses"),
        meta: { requiresAuth: true },
      },
      {
        path: "create-course",
        name: "create-course",
        component: () => import("@/pages/AdminCreateCourse"),
        meta: {
          requiresAuth: true,
          roles: ["admin", "teacher"],
        },
      },
      {
        path: "cms",
        name: "cms",
        component: () => import("@/pages/Admin/CMS/CMSContent"),
        meta: {
          requiresAuth: true,
          roles: ["admin"],
        },
      },
      {
        path: "user-feedback",
        name: "UserFeedback",
        component: () => import("@/pages/Admin/FeedbackForm"),
        meta: {
          requiresAuth: true,
          roles: ["admin"],
        },
      },
      {
        path: "cms/privacy",
        name: "privacy-statement",
        component: () => import("@/pages/Admin/CMS/PrivacyPolicy"),
        meta: {
          requiresAuth: true,
          roles: ["admin"],
        },
      },
      {
        path: "cms/terms-service",
        name: "TermsOfService",
        component: () => import("@/pages/Admin/CMS/TermsOfService"),
        meta: {
          requiresAuth: true,
          roles: ["admin"],
        },
      },
      {
        path: "course-editor/:id",
        name: "test-create-course",
        component: () => import("@/pages/TestCreateCourse"),
        meta: {
          requiresAuth: true,
          roles: ["admin", "teacher"],
        },
      },
      {
        path: "allcourses",
        name: "AdminCourses",
        component: () => import("@/pages/Admin/AdminCourses"),
        meta: {
          requiresAuth: true,
          roles: ["admin", "teacher"],
        },
      },
      {
        path: "courses",
        name: "Course",
        component: () => import("@/pages/Admin/CourseTypes/Courses"),
        meta: {
          requiresAuth: true,
          roles: ["admin", "teacher"],
        },
      },
      {
        path: "programs",
        name: "programs",
        component: () => import("@/pages/Admin/CourseTypes/Programs"),
        meta: {
          requiresAuth: true,
          roles: ["admin", "teacher"],
        },
      },
      {
        path: "trainings",
        name: "Trainings",
        component: () => import("@/pages/Admin/CourseTypes/Trainings"),
        meta: {
          requiresAuth: true,
          roles: ["admin", "teacher"],
        },
      },
      {
        path: "mentorship/applications",
        name: "MentorshipApplications",
        component: () => import("@/pages/Admin/Mentorship/MentorApplications"),
        meta: {
          requiresAuth: true,
          roles: ["admin"],
        },
      },
      {
        path: "mentorship/mentors",
        name: "MentorshipMentors",
        component: () => import("@/pages/Admin/Mentorship/Mentors"),
        meta: {
          requiresAuth: true,
          roles: ["admin"],
        },
      },

      {
        path: "mentor-details/:id",
        name: "MentorDetails",
        component: () => import("@/pages/Admin/Mentorship/MentorDetails"),
        meta: {
          requiresAuth: true,
          roles: ["admin"],
        },
      },
      {
        path: "mentor-dashboard",
        name: "MentorDashboard",
        component: () => import("@/pages/Mentors/MentorDashboard"),
        meta: {
          requiresAuth: true,
          roles: ["mentor"],
        },
      },
      {
        path: "mentor-notes",
        name: "MentorNotes",
        component: () => import("@/pages/Mentors/MentorNotes"),
        meta: {
          requiresAuth: true,
          roles: ["mentor"],
        },
      },
      {
        path: "mentor-profile",
        name: "MentorProfile",
        component: () => import("@/pages/Mentors/MentorProfile"),
        meta: {
          requiresAuth: true,
          roles: ["mentor"],
        },
      },
      {
        path: "course/:id",
        name: "UserCourseDetail",
        component: () => import("@/pages/Members/MyCourse"),
        meta: {
          requiresAuth: true,
          roles: ["student", "admin"],
        },
      },
      {
        path: "my-mentors",
        name: "MyMentors",
        component: () => import("@/pages/Members/MyMentors"),
        meta: {
          requiresAuth: true,
          roles: ["student"],
        },
      },
      {
        path: "my-mentor/:id",
        name: "MyMentorDetails",
        component: () => import("@/pages/Members/MyMentorDetails"),
        meta: {
          requiresAuth: true,
          roles: ["student"],
        },
      },
      {
        path: "my-notes",
        name: "MyNotes",
        component: () => import("@/pages/Members/MyNotes"),
        meta: {
          requiresAuth: true,
          roles: ["student"],
        },
      },
      {
        path: "mentors",
        name: "MentorsPage",
        component: () => import("@/pages/Members/AllMentors.vue"),
        meta: {
          requiresAuth: true,
          roles: ["student"],
        },
      },
      {
        path: "mentor/:id",
        name: "MentorDetailsForUser",
        component: () => import("@/pages/Members/ViewMentor.vue"),
        meta: {
          requiresAuth: true,
          roles: ["student"],
        },
      },
      {
        path: "mycourses/:id",
        name: "UserCourseView",
        component: () => import("@/pages/Members/Course.vue"),
        meta: {
          requiresAuth: true,
          roles: ["student", "admin"],
        },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  const isLoggedIn = store.getters.isLoggedIn;
  const user = JSON.parse(localStorage.getItem("user"));
  const userRole = user?.role || null;

  // Redirect unauthenticated users
  if (to.meta.requiresAuth && !isLoggedIn) {
    return next({ path: "/login", query: { redirect: to.fullPath } });
  }

  // Prevent logged-in users from accessing guest-only pages
  if (to.meta.requiresGuest && isLoggedIn) {
    return next("/dashboard");
  }

  // Check role permissions
  if (to.meta.roles && !to.meta.roles.includes(userRole)) {
    next({ name: "Unauthorized", props: { errorCode: 403 } });
  }

  // not direct to /dashboard/course/:id if payment is not declared
  if (to.name === "UserCourseDetail") {
    const courseId = to.params.id;
    try {
      const coursePayment = await api.get(
        `/api/enrollments/my-enrollment/${courseId}`
      );
      if (
        coursePayment.data?.paymentStatus !== "paid" &&
        userRole !== "admin" &&
        userRole !== "teacher"
      ) {
        return next({ name: "Unauthorized", query: { error: 403 } });
      }
    } catch (error) {
      return next({ name: "Unauthorized", query: { error: 403 } });
    }
  }

  // not allow user to see /dashboard/mycourse:/id page if he is not ennrolled in course
  if (to.name === "UserCourseView") {
    const courseId = to.params.id;
    const courseEnrollment = await api.get(
      `/api/enrollments/my-enrollment/${courseId}`
    );
    if (
      !courseEnrollment.data &&
      userRole !== "admin" &&
      userRole !== "teacher"
    ) {
      return next({ name: "Unauthorized", props: { errorCode: 403 } });
    }
  }

  next();
});

export default router;
